<template>
  <div
    v-if="enabled"
    class="favorite group z-30 flex items-center justify-center hover:bg-app-green-100 rounded-full cursor-pointer"
    :class="{ 'w-6 h-6 lg:w-10 lg:h-10': !large && !medium, 'w-8 h-8': medium, 'w-10 h-10': large, 'bg-app-green-100': isFavorite, 'bg-app-gray-silverstone': !isFavorite }"
    @click="toggle"
  >
    <AtomIconHeartFilled
      class="group-hover:text-app-green transform group-hover:scale-125 transition duration-200"
      :class="{ 'text-app-green': isFavorite, 'text-app-gray': !isFavorite, 'w-4 h-4': large || medium, 'w-3 h-3 lg:w-4 lg:h-4': !large && !medium }"
    />
  </div>
</template>

<script setup lang="ts">
import { useWishListStore } from '~/store/wishList'
import { setupSiteConfig } from '~/composables/craft'

interface Props {
  animalId: string | number
  medium?: boolean
  large?: boolean
}

const props = defineProps<Props>()

const wishListStore = useWishListStore()
const { domain } = setupSiteConfig()

const enabled = domain === 'ikZoekBaas'
const toggle = () => wishListStore.toggleFavorite(props.animalId)
const isFavorite = computed(() => wishListStore.isFavorite(props.animalId))
</script>
